export default __webpack_public_path__ + "5e22047db9e83eb3663c8cb09e674f76.png";